import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="dismissable"
export default class extends Controller {
  connect() {
    setTimeout(() => {
      this.element.remove();
    }, 6000);
  }

  dismiss() {
    this.element.remove();
  }
}
